import React, {useState} from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import Alert from './Alert'

type Props = {
    text?: string,
    icon1?: string,
    icon2?: string,
    style?: string,
    active?: boolean,
    available: boolean,
    url: string,
    darkMode?: boolean,
    onClick: (e) => void
}

const SideNavItem: React.FC<Props> = ({icon1, icon2, text, active, style, onClick, url, available}) => {
    const navigate = useNavigate();
    
    return (
        <div onClick={() => {
                if (!available) {
                    Alert('info', "Sorry, this feature is not available yet.");
                    return;
                }
                navigate(url);
            }}
            data-name={text?.toLocaleLowerCase().replace(" ", "_")}
        >
            {text === ""
                ?   <div className={`${style}`}></div>

                :   <div data-name={text?.toLocaleLowerCase().replace(" ", "_")} 
                        className={`flex justify-between tablet:justify-start py-4 pl-12 hover:bg-[#2c2c2e] mobile:pl-0 ${text !== '' && 'cursor-pointer'} text-white ${style}`} 
                        onClick={(e) => onClick(e)} 
                        style={{ ...(active && {background: 'rgba(218,220,232, .2)'}) }}
                    >
                        <span className='flex gap-3 w-full items-center pointer-events-none mobile:mx-8'>
                            <span className="flex-shrink-0 pointer-events-none">
                                <img src={active ? icon1 : icon2} alt='nav_icons' className='w-4 h-auto'/>
                            </span>
                            <span className='pointer-events-none'>{text}</span>
                        </span>
                        {active && <span className='h-[35px] w-1 bg-Primary rounded-l pointer-events-none'></span>}
                    </div>
            }
        </div>
    )
}

export default SideNavItem

// DADCE8